import styled from "styled-components"

export const StyledWhatSayAboutMeSection = styled.section`
  width: 100%;
  padding-bottom: 160px;
  position: relative;
  padding-top: 80px;
  @media only screen and (max-width: 703px) {
    padding-bottom: 120px;
  }
  @media only screen and (max-width: 430px) {
    padding-top: 40px;
  }
`
